{
  "instances": {
    "quartz": {
      "actions": "操作",
      "active_triggers": "活躍觸發器",
      "associated_triggers": "相關聯的觸發器",
      "associated_with_calendar": "與日曆關聯",
      "basic_information": "基本信息",
      "calendar": "日曆",
      "class": "類別",
      "configuration": "配置",
      "cron_expression": "Cron 表達式",
      "custom_trigger": "自訂觸發器",
      "days_of_week": "星期幾",
      "description": "描述",
      "details": "詳細信息",
      "disabled": "停用",
      "durable": "持久",
      "enabled": "啟用",
      "end_time": "結束時間",
      "final_fire_time": "最終執行時間",
      "friday": "星期五",
      "group": "組",
      "infinite": "無限",
      "interval": "間隔",
      "job_data": "工作數據",
      "job_name": "工作名稱",
      "jobs": "工作",
      "key": "鍵",
      "label": "Quartz",
      "last_fire": "最後一次觸發",
      "last_fire_time": "最後一次執行時間",
      "monday": "星期一",
      "name": "名稱",
      "next_fire": "下次觸發",
      "next_fire_time": "下次執行時間",
      "no": "否",
      "no_data": "沒有可用的 Quartz 資訊",
      "paused_triggers": "暫停的觸發器",
      "preserve_hour_of_day": "保留當天時刻",
      "priority": "優先權",
      "recovery": "恢復",
      "repeat_count": "重複次數",
      "request_recovery": "請求恢復",
      "saturday": "星期六",
      "schedule_configuration": "日程配置",
      "skip_day_if_hour_does_not_exist": "如果時刻不存在，跳過該天",
      "start_time": "開始時間",
      "state": "狀態",
      "sunday": "星期日",
      "system_default": "系統預設",
      "thursday": "星期四",
      "time_window": "時間窗口",
      "time_zone": "時區",
      "times_triggered": "執行次數",
      "timing_information": "時間信息",
      "total": "總計",
      "trigger_data": "觸發器數據",
      "trigger_failed": "觸發失敗",
      "trigger_failed_message": "觸發任務失敗: {error}",
      "trigger_failed_notification": "觸發任務 \"{jobName}\" 失敗: {error}",
      "trigger_fire_times": "觸發時間",
      "trigger_job_now": "立即執行工作",
      "trigger_success_message": "任務 \"{jobName}\" 已成功觸發",
      "trigger_success_title": "任務已觸發",
      "triggers": "觸發器",
      "tuesday": "星期二",
      "type": "類型",
      "value": "值",
      "wednesday": "星期三",
      "yes": "是"
    }
  }
}
